import { Box, Container, Divider, Grid, Paper, TextField, Typography } from "@mui/material";
import CartItems from "./CartItems";

import globalContext from '../../context/context'
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

function CartNotSuccess({message, clientSecret}) {

    const { t } = useTranslation();

    const { contextData: { orderId } } = useContext(globalContext);

    return (
        <>
            <Container disableGutters sx={{ pt: 4 }}>
                <Typography sx={{ fontSize: { xs: '24px', md: '32px' }, fontWeight: 300, textAlign: 'center', pb: 2 }}>{t("cart.notSuccessfulPayment")}</Typography>

                <Box sx={{ mx: { xs: 0, md: '25%' } }}>
                    {message&&<Box sx={{ fontSize: 16, pb: 4, textAlign: 'center' }}>
                        {message}
                    </Box>}
                    <Box onClick={() => window.location.reload()} sx={{ fontSize: 16, pb: 4, textAlign: 'center', cursor: 'pointer' }}> 
                        {t("cart.tryAgain")}
                    </Box>
                    <CartItems />


                </Box>
            </Container>

        </>
    );
}

export default CartNotSuccess;
